import { NgModule } from '@angular/core';
import { Highlight } from './highlight';

@NgModule({
  declarations: [Highlight],
  exports: [Highlight]
})
export class HighlightModule {
}
